module.exports = __webpack_public_path__ + "img/approval.380457df.png";